import { render, staticRenderFns } from "./ForumBoardAdmin.vue?vue&type=template&id=53ae2b52&scoped=true&"
import script from "./ForumBoardAdmin.vue?vue&type=script&lang=js&"
export * from "./ForumBoardAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ForumBoardAdmin.vue?vue&type=style&index=0&id=53ae2b52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ae2b52",
  null
  
)

export default component.exports